import APICall from '../utils/APICall';

export default class  ModuleServices {
  
    static listModules = async () => {
        return await APICall('/api/Module/admin/listModules', "GET");
    }
}